import './styles/playerinfo.css'
import { useLocation, useNavigate } from 'react-router-dom'
import { useEffect, useRef, useState } from 'react'

//Components
import Loader from '../components/loader'
import Snack from '../components/snack'
import Confirm from '../components/confirm'
import LogoTicket from '../assets/images/logo-ticket.png'
import { IoMdClose } from "react-icons/io"
import { MdDeleteOutline } from "react-icons/md"
import TicketModal from '../components/ticketmodal'
import Menu from '../components/menu'
import PlayerProfile from '../components/player-profile'

//Extras
import { fontType, main } from '../assets/extras'
import { addDoc, arrayRemove, arrayUnion, collection, deleteDoc, doc, getDoc, getDocs, increment, orderBy, query, setDoc, updateDoc, where } from 'firebase/firestore'
import { db } from '../assets/connections'
import { addMonthToADate, addYearToADate, compareDates, getAge, getCurrentDate, guessMonthNumb, validateEmail, validatePhone } from '../assets/validator'
import { categorias, horas, niveles } from '../assets/datas'
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import * as XLSX from "xlsx"

const PlayerInfo = () => {

    const navigate = useNavigate()
    
    const location = useLocation()
    const ref = location.state ? location.state.ref : null
    const id = location.state ? location.state.id : null
    const academia = location.state ? location.state.academia : null

    const contentRef = useRef()

    const [variables, setVariables] = useState({
        loading: true,
        player: "",
        player_ref: null,
        data: {},
        sedes: [],
        suscripciones: [],
        allSuscriptions: [],
        classes: [],
        paymentHistory: [],
        clase: [],
        confirm: false,
        sorted_classes: [
            [],
            [],
            [],
            [],
            [],
            [],
            []
        ],
        newPayment: {
            cantidad_pago: 0,
            comentarios_pago: "",
            concepto_pago: "Pago en una exhibicion",
            fecha_pago: getCurrentDate(),
            forma_pago: ""
        },
        showPlayerProfile: false,
        newPlayerEvent: {
            nombre_evento: "",
            comentarios_evento: "",
            fecha_evento: ""
        }
    })

    const [ticket, setTicket] = useState({
        show: false,
        forma_pago: "",
        comentarios: ""
    })

    //Varibles para el uso del confirm
    const [ confirm, setConfirm ] = useState({
        show: false,
        title: "",
        text: ""
    })

    //Varibles para el uso del confirm
    const [ confirmBaja, setConfirmBaja ] = useState({
        show: false,
        title: "",
        text: ""
    })

    //Control del mensaje snack
    const showMessage = (message, status) => {
        let contSnack = document.getElementById("contSnack")

        let snack = document.createElement("div")
        snack.classList.add("snack")

        snack.innerHTML = status == "success" ?
            "<i class='fa-regular fa-circle-check fa-beat' style='color: #56d600;'></i>" +
            "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
            "<div className='snackBar' style='background-color: #56d600;'></div>"
            : status == "warning" ?
                "<i class='fa-solid fa-triangle-exclamation fa-beat' style='color: #f9b92f;'></i>" +
                "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                "<div className='snackBar' style='background-color: #f9b92f;'></div>"
                : status == "error" ?
                    "<i class='fa-solid fa-circle-xmark fa-beat' style='color: #c20000;'></i>" +
                    "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                    "<div className='snackBar' style='background-color: #c20000;'></div>"
                    : ""

        contSnack.appendChild(snack)
        setTimeout(() => {
            snack.remove()
        }, 5000)
    }

    //Funcion que guarda el evento den bd
    const saveEvent = async () => {

        let newEvents = []
        if(variables.data.eventos_jugador){
            newEvents = [...variables.data.eventos_jugador, {...variables.newPlayerEvent}]
        } else {
            newEvents = [{...variables.newPlayerEvent}]
        }

        await updateDoc(doc(doc(db, ref), "Jugador", variables.player), {
            eventos_jugador: newEvents
        }).then(r => {
            setTimeout(() => {
                showMessage("Jugador actualizado", "success")
            }, 100)
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Error de conexion", "error")
            }, 100)
        })
    }

    //Variable que almacena los datos ordenados por dias
    var sortedDaysData = [
        [], //Lunes
        [], //Martes
        [], //Miercoles
        [], //Jueves
        [], //Viernes
        [], //Sabado
        [], //Domingo
    ]

    //Funcion que busca a que dia pertenece la clase
    const sortByDay = (clase) => {
        for(let i = 0; i < 7; i++){
            if(i === 0){ //Lunes
                let cont = 0
                for(let j = 0; j < clase.dias_clase.length; j++){
                    if(clase.dias_clase[j].dia === "Lunes"){
                        sortedDaysData[i].push(clase)
                        cont ++
                        break
                    }
                }

                if(cont > 0){
                    break
                }
            } else if(i === 1){ //Martes
                let cont = 0
                for(let j = 0; j < clase.dias_clase.length; j++){
                    if(clase.dias_clase[j].dia === "Martes"){
                        sortedDaysData[i].push(clase)
                        cont ++;
                        break
                    }
                }

                if(cont > 0){
                    break
                }
            } else if(i === 2){ //Miercoles
                let cont = 0
                for(let j = 0; j < clase.dias_clase.length; j++){
                    if(clase.dias_clase[j].dia === "Miercoles"){
                        sortedDaysData[i].push(clase)
                        cont ++
                        break
                    }
                }

                if(cont > 0){
                    break
                }
            } else if(i === 3){ //Jueves
                let cont = 0
                for(let j = 0; j < clase.dias_clase.length; j++){
                    if(clase.dias_clase[j].dia === "Jueves"){
                        sortedDaysData[i].push(clase)
                        cont ++
                        break
                    }
                }

                if(cont > 0){
                    break
                }
            } else if(i === 4){ //Viernes
                let cont = 0
                for(let j = 0; j < clase.dias_clase.length; j++){
                    if(clase.dias_clase[j].dia === "Viernes"){
                        sortedDaysData[i].push(clase)
                        cont ++
                        break
                    }
                }

                if(cont > 0){
                    break
                }
            } else if(i === 5){ //Sabado
                let cont = 0
                for(let j = 0; j < clase.dias_clase.length; j++){
                    if(clase.dias_clase[j].dia === "Sabado"){
                        sortedDaysData[i].push(clase)
                        cont ++
                        break
                    }
                }

                if(cont > 0){
                    break
                }
            } else if(i === 6){ //Domingo
                let cont = 0
                for(let j = 0; j < clase.dias_clase.length; j++){
                    if(clase.dias_clase[j].dia === "Domingo"){
                        sortedDaysData[i].push(clase)
                        cont ++
                        break
                    }
                }

                if(cont > 0){
                    break
                }
            }
        }
    }

    //Funcion que copia la informacion del jugador
    const onHandleCopyPlayer = async () => {
        var newData = variables.data
        newData.clases_jugador = []
        newData.ultima_asistencia = "----/--/--"
        newData.asistencias = []
        newData.suscripciones_jugador = [
            {
                suscripcion: "Inscripcion",
                fecha_pago: "----/--/--",
                por_pagar: 0,
                pagado: 0,
                comentarios: "",
            }, {
                suscripcion: "Mensualidad",
                fecha_pago: "----/--/--",
                por_pagar: 0,
                pagado: 0,
                comentarios: "",
            }
        ]

        await navigator.clipboard.writeText(JSON.stringify(newData)).then(r => {
            setTimeout(() => {
                showMessage("Jugador copiado al portapapeles", "success")
            }, 100)
        }).catch( e => {
            setTimeout(() => {
                showMessage("No se ha podido copiar al jugador", "error")
            }, 100)
        })
    }

    //Funcion que formatea el subitulo
    const formatSubtitle = (dias_clase) => {
        var dias = ""
        dias_clase.map(v => {
            var dia = ""
            var hora = v.de + "-" + v.a
            for (let i = 0; i < 3; i++) {
                dia += v.dia[i]
            }

            if (dias == "") {
                dias = dia + " " + hora
            } else {
                dias += " / " + dia + " " + hora
            }

        })

        return dias
    }

    //Funcion que valida si el jugador ya esta en la clase que se quiere registrar
    const isInClass = async (itemValue) => {
        itemValue = JSON.parse(itemValue)

        if(itemValue.id != ""){
            var count = 0
            for (let i = 0; i < variables.clase.length; i++) {
                if (variables.clase[i] == itemValue.id) {
                    count++
                }
            }

            if (count > 0) {
                setTimeout(() => {
                    showMessage("El jugador ya esta registrado en esa clase", "warning")
                }, 100)
            } else {
                var limite = parseInt(itemValue.limite_jugadores)
                if(limite === 0){
                    await updateDoc(doc(doc(db, ref), "Jugador", id), {
                        clases_jugador: arrayUnion(itemValue.id)
                    }).then(async r1 => {
                        await updateDoc(doc(doc(db, ref), "Clases", itemValue.id), {
                            numero_jugadores: increment(1)
                        }).then(r2 => {
                            variables.clase.push(itemValue.id)
                            setVariables(prev => ({
                                ...prev
                            }))
                            showMessage("Jugador agregado", "success")
                        }).catch(e => {
                            console.log(e)
                            showMessage("Error al actualizar clase")
                        })
                    }).catch(e => {
                        console.log(e)
                        showMessage("Error al actualizar jugador")
                    })
                } else {
                    if((itemValue.numero_jugadores + 1) <= limite){
                        await updateDoc(doc(doc(db, ref), "Jugador", id), {
                            clases_jugador: arrayUnion(itemValue.id)
                        }).then(async r1 => {
                            await updateDoc(doc(doc(db, ref), "Clases", itemValue.id), {
                                numero_jugadores: increment(1)
                            }).then(r2 => {
                                variables.clase.push(itemValue.id)
                                setVariables(prev => ({
                                    ...prev
                                }))
                                showMessage("Jugador agregado", "success")
                            }).catch(e => {
                                console.log(e)
                                showMessage("Error al actualizar clase")
                            })
                        }).catch(e => {
                            console.log(e)
                            showMessage("Error al actualizar jugador")
                        })
                    } else {
                        showMessage("Ya no hay espacio en la clinica", "warning")
                    }
                }
            }
        }
    }

    //Funcion que quita al jugador de una clase en especifico
    const takeOutPlayer = async (index) => {
        //Actualizamos en tiempo real la clase para la resta del jugador
        await updateDoc(doc(doc(db, ref), "Jugador", id), {
            clases_jugador: arrayRemove(variables.clase[index])
        }).then(async r1 => {
            await updateDoc(doc(doc(db, ref), "Clases", variables.clase[index]), {
                numero_jugadores: increment(-1)
            }).then(r => {
                variables.clase.splice(index, 1)
                setVariables(prev => ({
                    ...prev
                }))
                showMessage("Jugador retirado correctamente", "success")
            }).catch(e => {
                console.log(e)
                showMessage("Error al retirar jugador de la clase", "error")
            })
        }).catch(e => {
            console.log(e)
            showMessage("No se pudo actualizar el jugador", "error")
        })
        
    }

    //Funcion que quita una suscripcion de las suscripciones generales
    const takeOutSuscription = (index) => {
        variables.suscripciones.splice(index, 1)
        setVariables(prev => ({
            ...prev,
            loading: true
        }))

        updatingSubscriptions()
    }

    //Funcion que elimina la suscripcion del jugador
    const updatingSubscriptions = async () => {
        await updateDoc(doc(doc(db, ref), "Jugador", variables.player), {
            suscripciones_jugador: variables.suscripciones
        }).then(r => {
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Jugador actualizado", "success")
            }, 100)
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Error de conexion", "error")
            }, 100)
        })
    }

    //Funcion para validar si el usuario pago la cuota de la suscripcion
    const validatePaymentDay = (data) => {

        //Primero vemos de que suscripcion estamos hablando
        var suscription = variables.allSuscriptions.filter(v => v.nombre_suscripcion === data.suscripcion)[0]

        if (data.fecha_pago === "----/--/--") {
            return "#FF0000"
        } else {
            
           //Primero validamos si es una anualidad
           if(suscription.fecha_pago === -1){
                const fecha_anterior = data.fecha_pago

                if (compareDates(getCurrentDate(), addYearToADate(fecha_anterior)) === 1) {
                    if (parseFloat(data.pagado) >= parseFloat(data.por_pagar)) {
                        return main
                    } else {
                        if (parseFloat(data.pago) > 0) {
                            return "#FF8000"
                        } else {
                            return "#FF0000"
                        }
                    }
                } else if (compareDates(getCurrentDate(), addYearToADate(fecha_anterior)) === 2 || compareDates(getCurrentDate(), addYearToADate(fecha_anterior)) === 0) {
                    return "#FF0000"
                }
           } 
           //Validamos si es una mensualidad
           else if(suscription.fecha_pago === -2){
                const fecha_anterior = data.fecha_pago

                if (compareDates(getCurrentDate(), addMonthToADate(fecha_anterior)) === 1) {
                    if (parseFloat(data.pagado) >= parseFloat(data.por_pagar)) {
                        return main
                    } else {
                        if (parseFloat(data.pagado) > 0) {
                            return "#FF8000"
                        } else {
                            return "#FF0000"
                        }
                    }
                } else if (compareDates(getCurrentDate(), addMonthToADate(fecha_anterior)) === 2 || compareDates(getCurrentDate(), addMonthToADate(fecha_anterior)) === 0) {
                    return "#FF0000"
                }
           } 
           //Validamos si es un pago personalizado
           else if(suscription.fecha_pago === 1) {

                //Primero obtenemos la fecha del dia de corte
                var newDate = getCurrentDate().split("-")
                newDate[2] = suscription.dia_pago.toString()
                newDate = newDate.join("-")

                //Ahora validamos que la fecha sea menor para poder ser considerada como pago
                if (compareDates(data.fecha_pago, newDate) === 1) {
                    return "#FF0000"
                } else if (compareDates(data.fecha_pago, newDate) === 2 || compareDates(data.fecha_pago, newDate) === 0) {
                    if (parseFloat(data.pagado) >= parseFloat(data.por_pagar)) {
                        return main
                    } else {
                        if (parseFloat(data.pagado) > 0) {
                            return "#FF8000"
                        } else {
                            return "#FF0000"
                        }
                    }
                }

           }

        }
    }

    //Funcion que obtiene el nivel del jugador de acuerdo a las clases en las que se encuentra
    const getPlayerLevel = () => {
        var aux = []
        variables.clase.map(v => {
            let clase = variables.classes.find(c => c.id == v)
            aux.push(clase.nivel_clase)
        })

        if(aux.length > 0){
            if(aux.includes(niveles[niveles.length - 1])){
                return niveles[niveles.length - 1]
            } else if (aux.includes(niveles[niveles.length - 2])){
                return niveles[niveles.length - 2]
            } else if (aux.includes(niveles[niveles.length - 3])){
                return niveles[niveles.length - 3]
            } else if (aux.includes(niveles[niveles.length - 4])){
                return niveles[niveles.length - 4]
            } else if (aux.includes(niveles[niveles.length - 5])){
                return niveles[niveles.length - 5]
            } else if (aux.includes(niveles[niveles.length - 6])){
                return niveles[niveles.length - 6]
            } else if (aux.includes(niveles[niveles.length - 7])){
                return niveles[niveles.length - 7]
            } else if (aux.includes(niveles[niveles.length - 8])){
                return niveles[niveles.length - 8]
            }
        } else {
            return niveles[0]
        }

    }

    //Funciones que guardan o actualizan la informacion 
    const saveData = () => {
        if(variables.data.nombre_jugador === "" || variables.data.nombre_jugador.length < 10){
            showMessage("Ingresa un nombre valido", "warning")
        } else {
            if(validatePhone(variables.data.telefono_jugador) === true){

                setVariables(prev => ({
                    ...prev,
                    loading: true
                }))
        
                savingData()
    
            } else {
                showMessage("Ingresa un numero de telefono valido", "warning")
            }
        }
    }
    const savingData = async () => {

        //Validamos si el correo fue modificado
        if (variables.data.correo_jugador != variables.player) {
            await getDoc(doc(doc(db, ref), "Jugador", variables.data.correo_jugador)).then(r => {
                if (r.exists()) {
                    //Si existe el documento
                    setVariables(prev => ({
                        ...prev,
                        loading: false
                    }))
                    setTimeout(() => {
                        showMessage("El correo ya esta en uso", "warning")
                    }, 100)
                } else { //Si no existe el documento
                    //Primero añadimos el jugador nuevo, y luego borramos al antiguo
                    playerExists()
                }
            }).catch(e => {
                console.log(e.code + " " + e.message)
                setVariables(prev => ({
                    ...prev,
                    loading: false
                }))
                setTimeout(() => {
                    showMessage("Error de conexion", "error")
                }, 100)
            })
        } else {
            await updateDoc(doc(doc(db, ref), "Jugador", variables.player), {
                clases_jugador: variables.clase,
                categoria_jugador: variables.data.categoria_jugador,
                nivel_jugador: getPlayerLevel() != undefined ? getPlayerLevel() : niveles[0],
                rama_jugador: variables.data.rama_jugador,
                nombre_jugador: variables.data.nombre_jugador,
                telefono_jugador: variables.data.telefono_jugador,
                edad_jugador: variables.data.edad_jugador,
                sede_default: variables.data.sede_default || "",
                nombre_sede_default: variables.data.nombre_sede_default || ""
            }).then(r => {
                setVariables(prev => ({
                    ...prev,
                    loading: false
                }))
                setTimeout(() => {
                    showMessage("Jugador actualizado", "success")
                }, 100)
            }).catch(e => {
                console.log(e.code + " " + e.message)
                setVariables(prev => ({
                    ...prev,
                    loading: false
                }))
                setTimeout(() => {
                    showMessage("Error de conexion", "error")
                }, 100)
            })
        }
    }
    const playerExists = async () => {
        await setDoc(doc(doc(db, ref), "Jugador", variables.data.correo_jugador), {
            ...variables.data,
            nivel_jugador: getPlayerLevel() != undefined ? getPlayerLevel() : niveles[0]
        }).then(r => {
            deleteDoc(doc(doc(db, ref), "Jugador", variables.player)).then(r => {
                setVariables(prev => ({
                    ...prev,
                    loading: false
                }))
                setTimeout(() => {
                    showMessage("Jugador actualizado", "success")
                }, 100)
            }).catch(e => {
                console.log(e.code + " " + e.message)
                setVariables(prev => ({
                    ...prev,
                    loading: false
                }))
                setTimeout(() => {
                    showMessage("Error al eliminar jugador antiguo", "error")
                }, 100)
            })
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Error de conexion", "error")
            }, 100)
        })
    }

    //Funcion que guarda los datos de un nuevo pago
    const saveSuscriptionsData = async (index) => {
        await updateDoc(doc(doc(db, ref), "Jugador", variables.player), {
            suscripciones_jugador: variables.suscripciones
        }).then(async r => {

            const saveFinance = window.confirm("¿Deseas guardar el pago en la lista de finanzas?")
            var newFinanceObject = {}

            if(saveFinance){
                let financeNumber = window.prompt("Cantidad a registrar en el libro de finanzas: ",
                    variables.newPayment.cantidad_pago
                )
        
                //Validamos si el numero recibido es un string vacio o null
                while(financeNumber === "" || financeNumber === null || parseInt(financeNumber) <= 0 || isNaN(financeNumber)){
                    financeNumber = window.prompt("Ingresa una cantidad valida mayor a 0: ",
                        variables.newPayment.cantidad_pago
                    )
                }
        
                newFinanceObject = {
                    cantidad: parseInt(financeNumber),
                    categoria: variables.newPayment.concepto_pago,
                    concepto: variables.newPayment.concepto_pago + " " + variables.data.nombre_jugador.split(" ").filter((v, i) => i <= 1).join(" ") 
                }
            }

            if(variables.newPayment.cantidad_pago <= 0 || variables.newPayment.cantidad_pago === "0"){

                if(saveFinance){
                    await updateFinances(newFinanceObject, variables.newPayment.fecha_pago)
                }

                setVariables(prev => ({
                    ...prev,
                    newPayment: {
                        cantidad_pago: 0,
                        comentarios_pago: "",
                        concepto_pago: "Pago en una exibicion",
                        fecha_pago: getCurrentDate(),
                        forma_pago: ""
                    },
                    loading: false
                }))
                setTimeout(() => {
                    showMessage("Pago actualizado correctamente", "success")
                }, 100)
            } else {
                addDoc(collection(doc(db, variables.player_ref), "HistorialPagos"), {
                    ...variables.newPayment,
                    comentarios_pago: ticket.comentarios === "" ? "Sin comentarios" : ticket.comentarios
                }).then(async r => {

                    if(saveFinance){
                        await updateFinances(newFinanceObject, variables.newPayment.fecha_pago)
                    }

                    setVariables(prev => ({
                        ...prev,
                        newPayment: {
                            cantidad_pago: 0,
                            comentarios_pago: "",
                            concepto_pago: "Pago en una exibicion",
                            fecha_pago: getCurrentDate(),
                            forma_pago: ""
                        },
                        loading: false
                    }))
                    setTimeout(() => {
                        showMessage("Pago actualizado correctamente", "success")
                    }, 100)
                }).catch(e => {
                    console.log(e.code + " " + e.message)
                    setTimeout(() => {
                        showMessage("Error al crear nuevo pago", "error")
                    }, 100)
                })
            }
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Error de conexion", "error")
            }, 100)
        })
    }

    //Funcion que da de baja al jugador
    const bajaPlayer = () => {
        setVariables(prev => ({
            ...prev,
            loading: true
        }))
        baja()
    }
    const baja = async () => {
        var datos = {
            ...variables.data,
            clases_jugador: [],
            suscripciones_jugador: [
                {
                    suscripcion: "Inscripcion",
                    fecha_pago: "----/--/--",
                    pagado: 0,
                    por_pagar: 0,
                    comentarios: ""
                },
                {
                    suscripcion: "Mensualidad",
                    fecha_pago: "----/--/--",
                    pagado: 0,
                    por_pagar: 0,
                    comentarios: ""
                }
            ],
            asistencias: [],
            ranking_jugador: 0,
            fecha_baja: getCurrentDate()
        }

        await setDoc(doc(doc(db, ref), "JugadorBaja", variables.player), datos).then(async r => {
            await updateClassCont(variables.clase)
            await deletingPlayerBaja()
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Error al eliminar jugador antiguo", "error")
            }, 100)
        })

    }
    const deletingPlayerBaja = async () => {
        await deleteDoc(doc(doc(db, ref), "Jugador", variables.data.correo_jugador)).then(async r => {
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Jugador eliminado", "success", 2000)
                setTimeout(() => {
                    window.history.back()
                }, 1000)
            }, 100)
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Error al eliminar jugador antiguo", "error")
            }, 100)
        })
    }
    //Funcion que actualiza el contador de jugadores de la clinica
    const updateClassCont = async (classes) => {
        classes.map(async v => {
            await updateDoc(doc(doc(db, ref), "Clases", v), {
                numero_jugadores: increment(-1)
            }).catch(e => {
                console.log(e)
            })
        })
    }

    //Funciones que borran al jugador
    const deletePlayer = () => {
        setConfirm(prev => ({
            ...prev,
            show: false
        }))
        setVariables(prev => ({
            ...prev,
            loading: true
        }))
        deletingPlayer()
    }
    const deletingPlayer = async () => {
        await deleteDoc(doc(doc(db, ref), "Jugador", variables.data.correo_jugador)).then(async r => {
            await updateClassCont(variables.clase)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Jugador eliminado", "success", 2000)
                setTimeout(() => {
                    window.history.back()
                }, 1000)
            }, 100)
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Error al eliminar jugador antiguo", "error")
            }, 100)
        })
    }

    //Funcion que obtiene el historial de pagos del jugador
    const getPaymentHistory = async () => {
        await getDocs(query(collection(db, variables.player_ref, "HistorialPagos"))).then(r => {
            var aux = []
            r.docs.map(v => {
                aux.push({
                    id: v.id,
                    ...v.data()
                })
            })
            aux.sort((a, b) => new Date(a.fecha_pago) - new Date(b.fecha_pago))
            aux.reverse()

            setVariables(prev => ({
                ...prev,
                loading: false,
                paymentHistory: aux
            }))
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Error al obtener historial", "error")
            }, 100)
        })
    }

    //Funcion que crea un nuevo pago
    const createPayment = async () => {

        var newFinanceObject = {
            cantidad: parseInt(variables.newPayment.cantidad_pago),
            categoria: "Otros",
            concepto: variables.newPayment.concepto_pago + " " + variables.data.nombre_jugador.split(" ").filter((v, i) => i <= 1).join(" ") 
        }

        await addDoc(collection(doc(db, variables.player_ref), "HistorialPagos"), {
            ...variables.newPayment,
            comentarios_pago: variables.newPayment.comentarios_pago === "" ? "Sin comentarios" : variables.newPayment.comentarios_pago
        }).then(async r => {
            await updateFinances(newFinanceObject, variables.newPayment.fecha_pago)
            await generatePDF()
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setTimeout(() => {
                showMessage("Error al crear nuevo pago", "error")
            }, 100)
        })
    }
    const updateFinances = async (financeData, fecha) => {
        await updateDoc(doc(doc(db, ref), "Finanzas", fecha), {
            ingresos: arrayUnion(financeData)
        }).catch(async e => {
            console.log(e.code + " " + e.message)
            //Si nos manda a este error, probablemente es que no exista el documento al que queremos mandar la informacion,
            // entonces debemos de crearlo
            await setDoc(doc(doc(db, ref), "Finanzas", fecha), {
                ingresos: [financeData],
                egresos: [],
                fecha: fecha
            }).catch(e => {
                console.log(e)
                setTimeout(() => {
                    showMessage("Error al registrar nuevas finanzas", "error")
                })
            })
        })
    }
    const generatePDF = async () => {
        const input = contentRef.current;
        html2canvas(input)
        .then((canvas) => {
            const input = contentRef.current;
            html2canvas(input).then((canvas) => {
                const imgData = canvas.toDataURL('image/png')
                const pdf = new jsPDF('p', 'mm', 'a4')
                pdf.addImage(imgData, 'PNG', 0, 0, 210, 297) // Ajusta las dimensiones a A4
                pdf.save(variables.data.nombre_jugador.trim().toLowerCase() + "_" + 
                "PagoUnaExhibicion.pdf")
            })

            setVariables(prev => ({
                ...prev,
                newPayment: {
                    cantidad_pago: 0,
                    comentarios_pago: "",
                    concepto_pago: "Pago en una exibicion",
                    fecha_pago: getCurrentDate(),
                    forma_pago: ""
                }
            }))

            setTimeout(() => {
                showMessage("Pago creado correctamente", "success")
            }, 100)
        })
    }
    const deletePayment = async (data, index) => {
        await deleteDoc(doc(doc(db, variables.player_ref), "HistorialPagos", data.id)).then(r => {
            variables.paymentHistory.splice(index, 1)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))

            setTimeout(() => {
                showMessage("Pago eliminado correctamente", "success")
            }, 100)
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setTimeout(() => {
                showMessage("Error al eliminar pago", "error")
            }, 100)
        })
    }

    //Funcion que genera el ticket
    const generateTicket = (data) => {

        setVariables(prev => ({
            ...prev,
            newPayment: {
                cantidad_pago: data.cantidad_pago,
                comentarios_pago: data.comentarios_pago,
                concepto_pago: data.concepto_pago,
                fecha_pago: data.fecha_pago
            }
        }))

        setTimeout(() => {
            const input = contentRef.current;
            html2canvas(input)
            .then((canvas) => {
                const input = contentRef.current;
                html2canvas(input).then((canvas) => {
                    const imgData = canvas.toDataURL('image/png')
                    const pdf = new jsPDF('p', 'mm', 'a4')
                    pdf.addImage(imgData, 'PNG', 0, 0, 210, 297) // Ajusta las dimensiones a A4
                    pdf.save(variables.data.nombre_jugador.trim().toLowerCase() + "_" + 
                    "ComprobanteDePago.pdf")
                })

                setVariables(prev => ({
                    ...prev,
                    newPayment: {
                        cantidad_pago: 0,
                        comentarios_pago: "",
                        concepto_pago: "Pago en una exibicion",
                        fecha_pago: getCurrentDate()
                    }
                }))

                setTimeout(() => {
                    showMessage("Pago creado correctamente", "success")
                }, 100)
            })
        }, 100)
    }

    //Funcion que crea un excel del historial de pagos
    const onHandleCreateXLSX = () => {

        const data = []
        variables.paymentHistory.map(v => {
            data.push({
                Concepto: v.concepto_pago,
                Fecha: v.fecha_pago,
                Comentarios: v.comentarios_pago,
                Cantidad: v.cantidad_pago
            })
        })

        // Crear la hoja de cálculo
        const worksheet = XLSX.utils.json_to_sheet(data)

        // Crear el libro de trabajo
        const workbook = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(workbook, worksheet, "HistorialPagos")

        // Generar archivo Excel
        XLSX.writeFile(workbook, "Historial" + variables.data.nombre_jugador.replace(" ", "") + ".xlsx")

        showMessage("XLSX generado correctamente", "success")
    }

    //Funcion que obtiene las suscripciones
    const getSubscriptions = async (cla, sus, dat, classes, player_ref) => {
        await getDocs(query(collection(doc(db, ref), "Suscripciones"), orderBy("nombre_suscripcion", "asc"))).then(async r => {
            var aux = []
            r.docs.map(v => {
                aux.push({
                    id: v.id,
                    ...v.data()
                })
            })

            // Cargar sedes
            var sedesAux = []
            try {
                const sedesSnap = await getDocs(collection(doc(db, ref), "Sedes"))
                sedesAux = sedesSnap.docs.map(s => ({
                    id: s.id, nombre_sede: s.data().nombre_sede, es_default: s.data().es_default || false
                }))
            } catch(e) { console.error("Error cargando sedes:", e) }

            setVariables(prev => ({
                ...prev,
                clase: cla,
                suscripciones: sus,
                data: dat,
                classes: classes,
                allSuscriptions: aux,
                sedes: sedesAux,
                player: dat.correo_jugador,
                player_ref: player_ref,
                loading: false
            }))
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Error de conexion", "error")
            }, 100)
        })
    }

    //Funcion que obtiene las clases
    const getClasses = async (cla, sus, dat, player_ref) => {
        await getDocs(query(collection(doc(db, ref), "Clases"), orderBy("nombre_profesor", "asc"))).then(r => {

            var aux = []

            r.docs.map(v => {
                if (v.id.split("-").length === 1) {
                    var datos = v.data()

                    var newObject = {
                        id: v.id,
                        descripcion_clase: datos.descripcion_clase,
                        nombre_clase: datos.nombre_clase,
                        nombre_profesor: datos.nombre_profesor,
                        dias_clase: datos.dias_clase,
                        nivel_clase: datos.nivel,
                        id_profesor: datos.profesor_clase,
                        limite_jugadores: datos.limite_jugadores,
                        numero_jugadores: datos.numero_jugadores
                    }
                    aux.push(newObject)
                }
            })

            //Ordenamos cada clase de la lista de las categorias por dias
            for(let i = 0; i < aux.length; i++){
                //Recibimos una sola clase de la lista+
                sortByDay(aux[i])
            }

            var aux2 = []
            //Una vez separadas las clases por dias, y teniendo un arreglo de clases por cada dia,
            //Ordenamos la lista que esta en los martes por ejemplo de menor a mayor
            for(let i = 0; i < sortedDaysData.length; i++){

                //Primero creamos una variable que contendra las horas de clase
                var h = horas.map((v, i) => [])

                for(let x = 0; x < sortedDaysData[i].length; x++){

                    //Creamos una variable que almacena las horas de comienzo de cada clase
                    var start = []

                    //Recorremos cada dia de las clases
                    for(let z = 0; z < sortedDaysData[i][x].dias_clase.length; z++){
                        //Las agregamos a la variable de almacenamiento de las horas
                        start.push(parseInt(sortedDaysData[i][x].dias_clase[z].de))
                    }

                    
                    //Ahora validamos recorriendo las horas a cual pertenece cada una
                    for(let z = 0; z < h.length; z++){
                        if(start.includes((z+1))){
                            h[z].push(sortedDaysData[i][x])
                            break
                        }
                    }

                }

                h.map((v, i) => {
                    v.map(v2 => {
                        aux2.push(v2)
                    })
                })

            }

            getSubscriptions(cla, sus, dat, aux2, player_ref)

        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Error de conexion", "error")
            }, 100)
        })
    }

    //Funcion que obtiene los datos del jugador
    const getData = async () => {
        await getDoc(doc(doc(db, ref), "Jugador", id)).then(r => {
            if (r.exists()) {
                getClasses(r.data().clases_jugador, r.data().suscripciones_jugador, r.data(), r.ref.path)
            } else {
                setVariables(prev => ({
                    ...prev,
                    loading: false
                }))
                setTimeout(() => {
                    showMessage("No se encontro al jugador", "error")
                }, 100)
            }
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Error de conexion", "error")
            }, 100)
        })
    }

    useEffect(() => {
        if(!sessionStorage.getItem("homeFlag") || !ref){
            navigate("/home", { replace: true })
        } else {
            getData()
        }
    }, [])

    if (variables.loading)
        return (
            <Loader
                loading={variables.loading}
            />
        )

    if (!variables.loading)
        return (
            <div className='mainPlayerInfo'>

                {/* COMPROBANTE DE PAGO */}
                <div class='body'
                    ref={contentRef}
                    style={{
                        width: '210mm',
                        height: '297mm',
                        padding: '20mm',
                        backgroundColor: 'white',
                        position: "absolute",
                        top: "-999999px",
                        fontFamily: fontType.text,
                        margin: 0,
                        padding: 20,
                        width: 800,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column"
                    }}
                >
                    {
                        <div className='ticket' style={{
                            border: "1px solid #ccc", 
                            borderRadius: 5,
                            padding: 20,
                            backgroundColor: "#f9f9f9",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "column",
                            width: "90%"
                        }}>
                            <img src={LogoTicket} style={{
                                width: 410,
                                height: 205,
                                marginBottom: 50
                            }} />
                            <h2 style={{
                                fontFamily: fontType.title,
                                fontSize: 20,
                                fontWeight: "bold",
                                color: "black",
                                marginTop: 0,
                                textAlign: "center",
                                justifyContent: "center"
                            }}>RECIBO DE PAGO ACADEMIA TENISTA</h2>
                            <p style={{ margin: "5px 0" }}>Fecha: <span style={{
                                textDecoration: "underline"
                            }}>{getCurrentDate()}</span></p>
                            <hr />
                            <p style={{ margin: "5px 0" }}>&nbsp;</p>
                            <div class='item' style={{
                                display: "flex",
                                justifyContent: "space-between",
                                width: "70%",
                            }}>
                                <p style={{ margin: "5px 0" }}>Nombre:&nbsp;</p>
                                <p style={{ margin: "5px 0" }}><span style={{
                                    textDecoration: "underline"
                                }}>{variables.data.nombre_jugador}</span></p>
                            </div>
                            <div class='item' style={{
                                display: "flex",
                                justifyContent: "space-between",
                                width: "70%",
                            }}>
                                <p style={{ margin: "5px 0" }}>Concepto:&nbsp;</p>
                                <p style={{ margin: "5px 0" }}><span style={{
                                    textDecoration: "underline"
                                }}>{variables.newPayment.concepto_pago}</span></p>
                            </div>
                            <div class='item' style={{
                                display: "flex",
                                justifyContent: "space-between",
                                width: "70%",
                            }}>
                                <p style={{ margin: "5px 0" }}>Cantidad:&nbsp;</p>
                                <p style={{ margin: "5px 0" }}>$<span style={{
                                    textDecoration: "underline"
                                }}>{variables.newPayment.cantidad_pago}</span></p>
                            </div>
                            <div class='item' style={{
                                display: "flex",
                                justifyContent: "space-between",
                                width: "70%",
                            }}>
                                <p style={{ margin: "5px 0" }}>Comentarios:&nbsp;</p>
                                <p style={{ margin: "5px 0" }}><span style={{
                                    textDecoration: "underline"
                                }}>{(variables.newPayment.comentarios_pago === "" || variables.newPayment.comentarios_pago === null) ? "Sin comentarios" : variables.newPayment.comentarios_pago}</span></p>
                            </div>
                            <div class='item' style={{
                                display: "flex",
                                justifyContent: "space-between",
                                width: "70%",
                            }}>
                                <p style={{ margin: "5px 0" }}>Forma de pago:&nbsp;</p>
                                <p style={{ margin: "5px 0" }}><span style={{
                                    textDecoration: "underline"
                                }}>{(variables.newPayment.forma_pago === "" || variables.newPayment.forma_pago === null) ? "Pago en una sola exhibicion" : variables.newPayment.forma_pago}</span></p>
                            </div>
                            <p style={{ margin: "5px 0" }}>&nbsp;</p>
                            <p style={{ margin: "5px 0" }}>&nbsp;</p>
                            <p class='footer' style={{
                                margin: "5px 0", 
                                fontStyle: "italic", 
                                width: "100%", 
                                textAlign: "center", 
                                justifyContent: "center"
                            }}>Recibo generado por aplicacion web</p>
                        </div>
                    }
                </div>
                {/*******************************************************/}

                <TicketModal
                    ticket={ticket}
                    setTicket={setTicket}
                    onHandleGenerateTicket={() => {
                        setTicket(prev => ({
                            ...prev,
                            show: false
                        }))
                        setVariables(prev => ({
                            ...prev,
                            loading: true
                        }))

                        saveSuscriptionsData()
                    }}
                />

                <PlayerProfile
                    variables={variables}
                    setVariables={setVariables}
                    showMessage={showMessage}
                    saveEvent={saveEvent}
                />

                <Confirm
                    confirm={confirm}
                    setConfirm={setConfirm}
                    onHandle={deletePlayer}
                />
                <Confirm
                    confirm={confirmBaja}
                    setConfirm={setConfirmBaja}
                    onHandle={() => {
                        setConfirmBaja(prev => ({
                            ...prev,
                            show: false
                        }))
                        setTimeout(() => {
                            bajaPlayer()
                        }, 50)
                    }}
                />

                <Snack />

                <h2 style={{
                    backgroundColor: main,
                    fontFamily: fontType.title,
                    paddingBottom: 0
                }}>{variables.data.nombre_jugador}</h2>
                <h2 style={{
                    backgroundColor: main,
                    fontFamily: fontType.text,
                    marginTop: -50,
                    marginBottom: 40,
                    fontSize: 18,
                    padding: 10,
                    paddingBottom: 20,
                    paddingTop: 0
                }}>{
                    localStorage.getItem("authToken") ? 
                        JSON.parse(localStorage.getItem("authToken")).nombre_academia
                    : ""
                }</h2>

                <Menu
                    academia={academia}
                    reference={ref}
                />

                <div className='playerInfoCont'>

                    <div className='info-one' style={{
                        fontFamily: fontType.text
                    }}>

                        <div className='info-one-item'>
                            <p>Nombre</p>
                            <input
                                style={{
                                    fontFamily: fontType.text
                                }}
                                placeholder={"Ingresa un nombre"}
                                value={variables.data.nombre_jugador}
                                maxLength={40}
                                onChange={e => {
                                    const t = e.target.value

                                    setVariables(prev => ({
                                        ...prev,
                                        data: {
                                            ...prev.data,
                                            nombre_jugador: t
                                        }
                                    }))
                                }}
                            />
                        </div>

                        <div className='info-one-item'>
                            <p>Rama</p>
                            <div className='custom-select'>
                                <select id="Rama" name="Rama" style={{
                                    fontFamily: fontType.text
                                }}
                                    value={variables.data.rama_jugador}
                                    onChange={e => {
                                        const t = e.target.value
                                        setVariables(prev => ({
                                            ...prev,
                                            data: {
                                                ...prev.data,
                                                rama_jugador: t
                                            }
                                        }))
                                    }}
                                >
                                    <option value="Todos">Todos</option>
                                    <option value="Varonil">Varonil</option>
                                    <option value="Femenil">Femenil</option>
                                </select>
                            </div>
                        </div>

                        <div className='info-one-item'>
                            <p>Categoria</p>
                            <div className='custom-select'>
                                <select id="Categoria" name="Categoria" style={{
                                    fontFamily: fontType.text
                                }}
                                    value={variables.data.categoria_jugador}
                                    onChange={e => {
                                        const t = e.target.value
                                        setVariables(prev => ({
                                            ...prev,
                                            data: {
                                                ...prev.data,
                                                categoria_jugador: t
                                            }
                                        }))
                                    }}
                                >
                                    <option value="Todos">Todos</option>
                                    <option value="">Sin categoria</option>
                                    {
                                        categorias.map(v => {
                                            return (
                                                <option value={v}>{v}</option>
                                            )
                                        })
                                    }
                                </select>
                            </div>
                        </div>

                        <div className='info-one-item'>
                            <p>Nivel</p>
                            <div className='custom-select'>
                                <select id="Nivel" name="Nivel" style={{
                                    fontFamily: fontType.text
                                }}
                                    value={variables.data.nivel_jugador}
                                    onChange={e => {
                                        const t = e.target.value
                                        setVariables(prev => ({
                                            ...prev,
                                            data: {
                                                ...prev.data,
                                                nivel_jugador: t
                                            }
                                        }))
                                    }}
                                >
                                    <option value="Todos">Todos</option>
                                    <option value="">Sin nivel</option>
                                    {
                                        niveles.map(v => {
                                            return (
                                                <option value={v}>{v}</option>
                                            )
                                        })
                                    }
                                </select>
                            </div>
                        </div>

                        <div className='info-one-item'>
                            <p>Edad: <span style={{fontWeight: "lighter"}}>{variables.data.edad_jugador ? getAge(variables.data.edad_jugador) : "Loading..."}</span></p>
                            <input
                                style={{
                                    fontFamily: fontType.text
                                }}
                                type='date'
                                onChange={e => {
                                    setVariables(prev => ({
                                        ...prev,
                                        data: {
                                            ...prev.data,
                                            edad_jugador: e.target.value
                                        }
                                    }))
                                }}
                                value={variables.data.edad_jugador}
                            />
                        </div>

                        {variables.sedes.length > 0 && (
                            <div className='info-one-item'>
                                <p>Sede</p>
                                <div className='custom-select'>
                                    <select value={variables.data.sede_default || ""}
                                        onChange={e => {
                                            const sede = variables.sedes.find(s => s.id === e.target.value)
                                            setVariables(prev => ({
                                                ...prev,
                                                data: {
                                                    ...prev.data,
                                                    sede_default: e.target.value,
                                                    nombre_sede_default: sede ? sede.nombre_sede : ""
                                                }
                                            }))
                                        }}>
                                        <option value="">Sin sede</option>
                                        {variables.sedes.map(s => (
                                            <option key={s.id} value={s.id}>{s.nombre_sede}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        )}

                        <div className='info-one-item'>
                            <p>Correo</p>
                            <input
                                style={{
                                    borderColor: validateEmail(variables.data.correo_jugador) ? "#DDD" : "#D00"
                                    ,fontFamily: fontType.text
                                }}
                                placeholder={validateEmail(variables.data.correo_jugador) ? "" : "No hay un correo registrado"}
                                defaultValue={validateEmail(variables.data.correo_jugador) ? variables.data.correo_jugador : ""}
                                maxLength={50}
                                onChange={e => {
                                    const t = e.target.value

                                    setVariables(prev => ({
                                        ...prev,
                                        data: {
                                            ...prev.data,
                                            correo_jugador: t
                                        }
                                    }))
                                }}
                            />
                        </div>

                        <div className='info-one-item'>
                            <p>Telefono</p>
                            <input
                                style={{
                                    borderColor: validatePhone(variables.data.telefono_jugador) ? "#DDD" : "#D00"
                                    ,fontFamily: fontType.text
                                }}
                                value={variables.data.telefono_jugador}
                                maxLength={10}
                                onChange={e => {
                                    const t = e.target.value

                                    setVariables(prev => ({
                                        ...prev,
                                        data: {
                                            ...prev.data,
                                            telefono_jugador: t
                                        }
                                    }))
                                }}
                            />
                        </div>

                        <div className='info-one-item'>
                            <p>Fecha de registro</p>
                            <p style={{
                                fontWeight: "lighter",
                                textAlign: "center",
                                marginBottom: 20
                            }}>{variables.data.fecha_alta ? variables.data.fecha_alta : variables.data.fecha_inscripcion ? variables.data.fecha_inscripcion : "No hay una fecha registrada"}</p>
                        </div>

                        <div className='info-one-item'>
                            <p>Ultima baja</p>
                            <p style={{
                                fontWeight: "lighter",
                                textAlign: "center",
                                marginBottom: 20
                            }}>{variables.data.fecha_baja ? variables.data.fecha_baja : "No ha sido dado de baja el jugador"}</p>
                        </div>

                        <div className='info-one-item'>
                            <p>Asistencias:</p>
                            <div style={{
                                width: "90%",
                                height: 400,
                                overflow: "scroll",
                                overflowX: "hidden",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                gap: 10,
                                marginTop: 10,
                                marginBottom: 10
                            }}>
                                {
                                    variables.data.asistencias.map((v, i) => {
                                        return (
                                            <div style={{
                                                width: "95%",
                                                border: "1px solid black",
                                                borderRadius: 10,
                                                padding: 10,
                                                display: "flex",
                                                alignItems: "center",
                                                flexDirection: "column"
                                            }}>
                                                <p style={{
                                                    fontFamily: fontType.title,
                                                    textAlign: "center",
                                                    fontSize: 18
                                                }}>{v.fecha_clase}</p>
                                                
                                                <div style={{
                                                    width: "100%",
                                                    marginTop: 10
                                                }}>
                                                    <p style={{
                                                        fontFamily: fontType.text,
                                                        textAlign: "left",
                                                        fontSize: 16
                                                    }}>Clase: <span style={{fontWeight: "lighter"}}>{v.nombre_clase}</span></p>
                                                    <p style={{
                                                        fontFamily: fontType.text,
                                                        textAlign: "left",
                                                        fontSize: 16
                                                    }}>Profesor: <span style={{fontWeight: "lighter"}}>{v.profesor_clase}</span></p>
                                                    <p style={{
                                                        fontFamily: fontType.text,
                                                        textAlign: "left",
                                                        fontSize: 16
                                                    }}>Hora: <span style={{fontWeight: "lighter"}}>{v.hora_clase}</span></p>
                                                </div>
                                            </div>
                                            
                                        )
                                    })
                                }
                            </div>
                        </div>

                        <div className='info-one-item'>
                            <p>Ranking</p>
                            <div className='ranking'>
                                <p>{variables.data.ranking_jugador}</p>
                            </div>
                        </div>

                        <div className='info-one-item' style={{
                            marginTop: 50
                        }}>
                            <button style={{
                                backgroundColor: main,
                                padding: 10,
                                borderRadius: 10,
                                color: "white",
                                fontFamily: fontType.title,
                                border: "none",
                                fontSize: 18,
                                cursor: "pointer"
                            }} onClick={() => setVariables(prev => ({
                                ...prev,
                                showPlayerProfile: true
                            }))}>
                                PERFIL DEPORTIVO
                            </button>
                        </div>

                    </div>

                    <div className='info-two' style={{
                        fontFamily: fontType.text
                    }}>

                        <div className='contClasses'>
                            <p style={{
                                fontWeight: "bold",
                                fontSize: 18
                            }}>Clases</p>
                            <div className='classes'>
                                {
                                    variables.clase.length > 0 ?
                                        variables.clase.map((v, i) => {
                                            let clase = variables.classes.find(c => c.id == v)

                                            return (
                                                <div className='clase'>
                                                    <div className='item' style={{
                                                        cursor: "pointer"
                                                    }}>
                                                        <p style={{
                                                            fontWeight: "bold",
                                                            marginBottom: 20
                                                        }} onClick={() => {
                                                            setVariables(prev => ({
                                                                ...prev,
                                                                loading: true
                                                            }))
                                                            setTimeout(async () => {
                                                                await getDoc(doc(db, "Profesores", clase.id_profesor)).then(r => {
                                                                    navigate("/teachers/teacher", {state: {
                                                                        ref: ref,
                                                                        data: {
                                                                            ...r.data(),
                                                                            id: r.data().correo_profesor
                                                                        },
                                                                        academia: academia
                                                                    }})
                                                                }).catch(e => {
                                                                    console.log(e)
                                                                    setVariables(prev => ({
                                                                        ...prev,
                                                                        loading: false
                                                                    }))
                                                                    setTimeout(() => {
                                                                        showMessage("Ocurrio algun error", "error")
                                                                    }, 50)
                                                                })
                                                            }, 50)
                                                        }}>{clase.nombre_profesor}</p>
                                                        <p>{clase.nombre_clase}</p>
                                                        <p onClick={() => {
                                                            navigate("/classes/class", {state: {
                                                                ref: ref,
                                                                id: v,
                                                                academia: academia
                                                            }})
                                                        }}>{clase.descripcion_clase}</p>
                                                    </div>
                                                    <div className='item' style={{
                                                        cursor: "pointer"
                                                    }}
                                                        onClick={() => {
                                                            takeOutPlayer(i)
                                                        }}
                                                    >
                                                        <MdDeleteOutline size={30} color='black' />
                                                    </div>
                                                </div>
                                            )
                                        })
                                    :
                                        <p style={{
                                            marginTop: 50,
                                            marginBottom: 50,
                                            textAlign: "center"
                                        }}>No hay clases para este jugador.</p>
                                }

                                <div className='custom-select'>
                                    <select id="Clases" name="Clases" style={{
                                        fontFamily: fontType.text,
                                        width: "100%"
                                    }}
                                    value={"..."}
                                        onChange={e => {
                                            const t = e.target.value

                                            isInClass(t)
                                        }}
                                    >
                                        <option value={""}>Agregar clases</option>
                                        {
                                            variables.classes.map((v, i) => {
                                                return (
                                                    <option style={{
                                                        borderBottomWidth: 1
                                                    }} value={JSON.stringify({id: v.id, limite_jugadores: v.limite_jugadores, numero_jugadores: v.numero_jugadores})}>{(v.dias_clase ? formatSubtitle(v.dias_clase) : "") + " " + v.nombre_profesor}</option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div className='contSuscripciones'>
                            <p style={{
                                fontWeight: "bold",
                                fontSize: 18
                            }}>Suscripciones</p>
                            <div className='suscripciones'>
                                {
                                    variables.suscripciones.length > 0 ?
                                        variables.suscripciones.map((v, i) => {
                                            return (
                                                <div className='suscripcion' style={{
                                                    borderColor: validatePaymentDay(v)
                                                }}>
                                                    <div className='contInfo'>
                                                        <p>{v.suscripcion}</p>
                                                        <div className='contPagos'>
                                                            <div className='pago'>
                                                                <p>Por pagar</p>
                                                                <input
                                                                    type='number'
                                                                    defaultValue={variables.suscripciones[i].por_pagar}
                                                                    onChange={e => {
                                                                        const t = e.target.value

                                                                        if(t === ""){
                                                                            variables.suscripciones[i].por_pagar = 0
                                                                        } else {
                                                                            variables.suscripciones[i].por_pagar = parseInt(t)
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className='pago'>
                                                                <p>Pagado</p>
                                                                <input
                                                                    type='number'
                                                                    defaultValue={variables.suscripciones[i].pagado}
                                                                    onChange={e => {
                                                                        const t = e.target.value

                                                                        if(t === ""){
                                                                            variables.suscripciones[i].pagado = 0
                                                                        } else {
                                                                            variables.suscripciones[i].pagado = parseInt(t)
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>

                                                        <input
                                                            className='input-fecha'
                                                            style={{
                                                                fontFamily: fontType.text,
                                                                padding: 5,
                                                                marginTop: 10,
                                                                borderRadius: 5,
                                                                borderWidth: 2,
                                                                borderColor: "#DDD",
                                                                borderStyle: "solid"
                                                            }}
                                                            placeholder='Comentarios'
                                                            value={variables.suscripciones[i].comentarios}
                                                            onChange={e => {
                                                                variables.suscripciones[i].comentarios = e.target.value
                                                                setVariables(prev => ({
                                                                    ...prev
                                                                }))
                                                            }}
                                                        />
                                                        
                                                        <input
                                                            className='input-fecha'
                                                            style={{
                                                                fontFamily: fontType.text,
                                                                padding: 5,
                                                                marginTop: 10,
                                                                borderRadius: 5,
                                                                borderWidth: 2,
                                                                borderColor: "#DDD",
                                                                borderStyle: "solid"
                                                            }}
                                                            type='date'
                                                            onChange={e => {
                                                                variables.suscripciones[i].fecha_pago = e.target.value
                                                                setVariables(prev => ({
                                                                    ...prev
                                                                }))
                                                            }}
                                                        />
                                                        <p style={{
                                                            width: "100%",
                                                            textAlign: "center"
                                                        }}>{v.fecha_pago}</p>

                                                        <button style={{
                                                            padding: 10,
                                                            backgroundColor: main,
                                                            color: "white",
                                                            fontFamily: fontType.subTitle,
                                                            border: "none",
                                                            borderRadius: 10,
                                                            cursor: "pointer",
                                                            marginTop: 20
                                                        }} onClick={() => {

                                                            if(v.fecha_pago === "----/--/--"){
                                                                showMessage("Debes seleccionar una fecha", "warning")
                                                            } else {

                                                                //Primero vemos de que suscripcion estamos hablando
                                                                /*
                                                                var suscription = variables.allSuscriptions.filter(s => s.nombre_suscripcion === v.suscripcion)[0]

                                                                //Primero obtenemos la fecha del dia de corte
                                                                var newDate = getCurrentDate().split("-")
                                                                newDate[2] = suscription.dia_pago.toString()
                                                                newDate = newDate.join("-")

                                                                if(suscription.fecha_pago < 0){
                                                                    const numero = parseInt(variables.suscripciones[i].pagado, 10)
                                                                    if(!isNaN(numero) && Number.isInteger(numero) && numero >= 0){

                                                                        variables.suscripciones[i].fecha_pago = variables.suscripciones[i].fecha_pago != "----/--/--" ? variables.suscripciones[i].fecha_pago : getCurrentDate()

                                                                        setVariables(prev => ({
                                                                            ...prev,
                                                                            newPayment: {
                                                                                cantidad_pago: variables.suscripciones[i].pagado,
                                                                                fecha_pago: variables.suscripciones[i].fecha_pago != "----/--/--" ? variables.suscripciones[i].fecha_pago : getCurrentDate(),
                                                                                comentarios_pago: "",
                                                                                concepto_pago: v.suscripcion
                                                                            }
                                                                        }))
            
                                                                        setTicket(prev => ({
                                                                            ...prev,
                                                                            show: true
                                                                        }))

                                                                    } else {
                                                                        showMessage("Ingresa un numero valido en el pago", "error")
                                                                    }
                                                                } else {
                                                                    if(compareDates(v.fecha_pago, newDate) === 2 || compareDates(v.fecha_pago, newDate) === 0){
                                                                        const numero = parseInt(variables.suscripciones[i].pagado, 10);
    
                                                                        if(!isNaN(numero) && Number.isInteger(numero) && numero >= 0){
    
                                                                            variables.suscripciones[i].fecha_pago = variables.suscripciones[i].fecha_pago != "----/--/--" ? variables.suscripciones[i].fecha_pago : getCurrentDate()
    
                                                                            setVariables(prev => ({
                                                                                ...prev,
                                                                                newPayment: {
                                                                                    cantidad_pago: variables.suscripciones[i].pagado,
                                                                                    fecha_pago: variables.suscripciones[i].fecha_pago != "----/--/--" ? variables.suscripciones[i].fecha_pago : getCurrentDate(),
                                                                                    comentarios_pago: "",
                                                                                    concepto_pago: v.suscripcion
                                                                                }
                                                                            }))
                
                                                                            setTicket(prev => ({
                                                                                ...prev,
                                                                                show: true
                                                                            }))
    
                                                                        } else {
                                                                            showMessage("Ingresa un numero valido en el pago", "error")
                                                                        }
                                                                    } else {
                                                                        showMessage("Debes seleccionar el dia " + suscription.dia_pago + " de " + guessMonthNumb(getCurrentDate().split("-")[1]) + " para registrar como pagado", "warning")
                                                                    }
                                                                }*/
                                                                const numero = parseInt(variables.suscripciones[i].pagado, 10);

                                                                if(!isNaN(numero) && Number.isInteger(numero) && numero >= 0){

                                                                    variables.suscripciones[i].fecha_pago = variables.suscripciones[i].fecha_pago != "----/--/--" ? variables.suscripciones[i].fecha_pago : getCurrentDate()

                                                                    setVariables(prev => ({
                                                                        ...prev,
                                                                        newPayment: {
                                                                            cantidad_pago: variables.suscripciones[i].pagado,
                                                                            fecha_pago: variables.suscripciones[i].fecha_pago != "----/--/--" ? variables.suscripciones[i].fecha_pago : getCurrentDate(),
                                                                            comentarios_pago: "",
                                                                            concepto_pago: v.suscripcion
                                                                        }
                                                                    }))
        
                                                                    setTicket(prev => ({
                                                                        ...prev,
                                                                        show: true
                                                                    }))

                                                                } else {
                                                                    showMessage("Ingresa un numero valido en el pago", "error")
                                                                }
                                                            }
                                                        }}>
                                                            GUARDAR
                                                        </button>
                                                    </div>
                                                    {
                                                        v.suscripcion === "Inscripcion" ?
                                                            null
                                                        :
                                                            <div className='contButton' style={{
                                                                cursor: "pointer"
                                                            }}
                                                                onClick={() => {
                                                                    //Sacar clase
                                                                    takeOutSuscription(i)
                                                                }}
                                                            >
                                                                <MdDeleteOutline size={30} color='black' />
                                                            </div>
                                                    }
                                                </div>
                                            )
                                        })
                                    :
                                        <p style={{
                                            marginTop: 50,
                                            marginBottom: 50,
                                            textAlign: "center"
                                        }}>No hay suscripciones para este jugador.</p>
                                }
                            </div>

                            <div className='custom-select'>
                                <select id="Suscripciones" name="Suscripciones" style={{
                                    fontFamily: fontType.text,
                                    width: "100%"
                                }}
                                value={"..."}
                                onChange={e => {
                                    const itemValue = JSON.parse(e.target.value)

                                    var suscripciones = variables.suscripciones
                                    var cont = 0
                                    for (let i = 0; i < suscripciones.length; i++) {
                                        if (suscripciones[i].suscripcion === itemValue.nombre_suscripcion) {
                                            cont++
                                        }
                                    }

                                    if (cont > 0) {
                                        showMessage("El jugador ya esta suscrito", "warning")
                                    } else {
                                        suscripciones.push({
                                            suscripcion: itemValue.nombre_suscripcion,
                                            fecha_pago: "----/--/--",
                                            por_pagar: 0,
                                            pagado: 0,
                                            comentarios: ""
                                        })

                                        setVariables(prev => ({
                                            ...prev,
                                            suscripciones: suscripciones,
                                            loading: true
                                        }))

                                        updatingSubscriptions()
                                    }
        
                                }}
                                >
                                    {
                                        variables.allSuscriptions.map((v, i) => {
                                            return (
                                                <option style={{
                                                    borderBottomWidth: 1
                                                }} value={JSON.stringify(v)}>{v.nombre_suscripcion}</option>
                                            )
                                        })
                                    }
                                </select>
                            </div>

                            <p style={{
                                fontFamily: fontType.text,
                                fontWeight: "bold",
                                borderTopWidth: 1,
                                borderTopStyle: "solid",
                                width: "90%",
                                textAlign: "center",
                                marginTop: 20
                            }}>Historial de pagos</p>

                            <button style={{
                                backgroundColor: main,
                                marginTop: 20,
                                marginBottom: 20,
                                padding: 10,
                                color: "white",
                                fontFamily: fontType.title,
                                borderRadius: 10,
                                border: "none",
                                cursor: "pointer",
                                fontSize: 18
                            }} onClick={onHandleCreateXLSX}>
                                CREAR XLSX
                            </button>

                            <div className='create-payment'>
                                <div className='item'>
                                    <p style={{
                                        fontWeight: "bold"
                                    }}>Cantidad</p>
                                    <input
                                        value={variables.newPayment.cantidad_pago}
                                        placeholder='$0'
                                        maxLength={10}
                                        type='number'
                                        onChange={e => {
                                            try {
                                                const t = parseInt(e.target.value)

                                                if(t > 0){
                                                    setVariables(prev => ({
                                                        ...prev,
                                                        newPayment: {
                                                            ...prev.newPayment,
                                                            cantidad_pago: t
                                                        }
                                                    }))
                                                } else {
                                                    showMessage("Debes ingresar una cantidad valida en el nuevo pago", "error")
                                                }
                                            } catch (error){
                                                showMessage("Debes ingresar una cantidad valida en el nuevo pago", "error")
                                            }
                                        }}
                                    />
                                </div>
                                <div className='item'>
                                    <p style={{
                                        fontWeight: "bold"
                                    }}>Comentarios</p>
                                    <input
                                        value={variables.newPayment.comentarios_pago}
                                        placeholder='...'
                                        maxLength={100}
                                        onChange={e => {
                                            const t = e.target.value

                                            setVariables(prev => ({
                                                ...prev,
                                                newPayment: {
                                                    ...prev.newPayment,
                                                    comentarios_pago: t
                                                }
                                            }))
                                        }}
                                    />
                                </div>
                                <div className='item'>
                                    <p style={{
                                        fontWeight: "bold"
                                    }}>Fecha</p>
                                    <input
                                        style={{
                                            fontFamily: fontType.text
                                        }}
                                        type='date'
                                        onChange={e => {
                                            setVariables(prev => ({
                                                ...prev,
                                                newPayment: {
                                                    ...prev.newPayment,
                                                    fecha_pago: e.target.value
                                                }
                                            }))
                                        }}
                                        value={variables.newPayment.fecha_pago}
                                    />
                                </div>
                                <div className='item'>
                                    <button style={{
                                        backgroundColor: "black",
                                        fontFamily: fontType.title,
                                        width: "80%",
                                        padding: 10,
                                        marginTop: 10,
                                        border: "none",
                                        borderRadius: 10,
                                        color: "white",
                                        fontSize: 18,
                                        cursor: "pointer"
                                    }} onClick={() => {
                                        createPayment()
                                    }}>
                                        CREAR PAGO
                                    </button>
                                </div>
                            </div>

                            <div style={{
                                width: "90%",
                                height: 300,
                                marginTop: 10,
                                display: "flex",
                                alignItems: "center",
                                flexDirection: "column",
                                overflowY: "scroll"
                            }}>
                                {
                                    variables.paymentHistory.length > 0 ?
                                        variables.paymentHistory.map((v, i) => {
                                            return (
                                                <div className='history' style={{
                                                    position: "relative"
                                                }}>
                                                    <IoMdClose style={{
                                                        position: "absolute",
                                                        right: 5,
                                                        top: 5,
                                                        cursor: "pointer"
                                                    }} id='outdia' size={20} color='#C00' onClick={() => {
                                                        setVariables(prev => ({
                                                            ...prev,
                                                            loading: true
                                                        }))

                                                        deletePayment(v, i)
                                                    }} />
                                                    <p style={{
                                                        fontFamily: fontType.title,
                                                        fontSize: 18
                                                    }}>CONCEPTO: {v.concepto_pago}</p>
                                                    <p><span style={{
                                                        fontWeight: "bold"
                                                    }}>Fecha:</span> {v.fecha_pago}</p>
                                                    <p><span style={{
                                                        fontWeight: "bold"
                                                    }}>Comentarios:</span> "{v.comentarios_pago}"</p>
                                                    <p style={{marginTop: 10}}><span style={{
                                                        fontWeight: "bold"
                                                    }}>Cantidad:</span> ${v.cantidad_pago}</p>

                                                    <button style={{
                                                        backgroundColor: main,
                                                        marginTop: 20,
                                                        padding: 10,
                                                        borderRadius: 10,
                                                        color: "white",
                                                        fontFamily: fontType.title,
                                                        border: "none",
                                                        fontSize: 16,
                                                        cursor: "pointer"
                                                    }} onClick={() => {
                                                        generateTicket(v)
                                                    }}>
                                                        COMPROBANTE
                                                    </button>
                                                </div>
                                            )
                                        })
                                    :
                                        <button style={{
                                            backgroundColor: main,
                                            width: "80%",
                                            height: 40,
                                            border: "none",
                                            borderRadius: 10,
                                            color: "white",
                                            fontFamily: fontType.subTitle,
                                            cursor: "pointer"
                                        }} onClick={() => {
                                            setVariables(prev => ({
                                                ...prev,
                                                loading: true
                                            }))
        
                                            getPaymentHistory()
                                        }}>
                                            Mostrar Historial
                                        </button>
                                }
                            </div>
                        </div>

                        <div className='contButtons'>
                            <button onClick={() => {
                                onHandleCopyPlayer()
                            }} id="copiar" style={{
                                fontFamily: fontType.subTitle
                            }}>Copiar jugador</button>
                            <div class='buttons'>
                                <button onClick={() => {
                                    saveData()
                                }} style={{
                                    fontFamily: fontType.subTitle,
                                    backgroundColor: main
                                }}>Guardar</button>
                                <button onClick={() => {
                                    setConfirmBaja(prev => ({
                                        ...prev,
                                        title: "DAR DE BAJA",
                                        text: "¿Estas seguro de dar de baja al jugador?",
                                        show: true
                                    }))
                                }} style={{
                                    fontFamily: fontType.subTitle,
                                    backgroundColor: "orange"
                                }}>Dar de baja</button>
                                <button onClick={() => {
                                    setConfirm(prev => ({
                                        ...prev,
                                        title: "Eliminar jugador",
                                        text: "¿Estas seguro de eliminar a este jugador permanentemente?",
                                        show: true
                                    }))
                                }} style={{
                                    fontFamily: fontType.subTitle,
                                    backgroundColor: "#A00"
                                }}>Eliminar</button>
                            </div>
                        </div>

                    </div>

                </div>

            </div>
        )
}

export default PlayerInfo